/** @jsx React.DOM */
'use strict';

var React = require('react'),
    Container = require('./Container'),
    LinkedStateMixin = require('react/lib/LinkedStateMixin'),
    $__0=    require('react-router'),Link=$__0.Link;

var DragAroundNaive = React.createClass({displayName: 'DragAroundNaive',
  mixins: [LinkedStateMixin],

  getInitialState:function() {
    return {
      hideSourceOnDrag: false
    };
  },

  render:function() {
    return (
      React.createElement("div", null, 
        React.createElement(Container, {hideSourceOnDrag: this.state.hideSourceOnDrag}), 
        React.createElement("p", null, 
          React.createElement("input", {type: "checkbox", 
                 checkedLink: this.linkState('hideSourceOnDrag')}, 
            "Hide source item while dragging"
          )
        ), 
        React.createElement("hr", null), 
        React.createElement("p", null, 
          "This example naively relies on browser drag and drop implementation without much custom logic."
        ), 
        React.createElement("p", null, 
          "When element is dragged, we remove its original DOM node and let browser draw the drag preview." + ' ' +
          "When element is released, we draw an element at the new coordinates." + ' ' +
          "If you try to drag an item outside the container, browser will animate its return."
        ), 
        React.createElement("p", null, 
          "While this approach works for simple cases, it flickers on drop." + ' ' +
          "This happens because browser removes drag preview before we have a chance to make dragged item visible." + ' ' +
          "This might not be a problem if you dim original item instead of hiding it, but it's clearly visible otherwise."
        ), 
        React.createElement("p", null, 
          "If we want to add custom logic such as snapping to grid or bounds checking, we can only do this on drop." + ' ' +
          "There is no way for us to control what happens to dragged preview once the browser has drawn it."
        ), 
        React.createElement("p", null, "Next: ", React.createElement(Link, {to: "drag-around-custom"}, "providing custom drag feedback"), ".")
      )
    );
  }
});

module.exports = DragAroundNaive;


/*****************
 ** WEBPACK FOOTER
 ** ./_drag-around-naive/index.js
 ** module id = 138
 ** module chunks = 0
 **/